<template>
	<div class="page">
		<div title="news" is='headered'></div>
		<div class="news_head">新闻资讯</div>

		<div class="messageBox">
			<div v-for='(message,index) in messageList' @click="toLinkUrl(index)" class="messageItem">
				<div class="messageImg">
					<img :src="message.imgUrl" />
				</div>
				<div class="messageItem_main">
					<div class="messageItem_title">{{message.title}}</div>
					<div class="messageItem_text">{{message.text}}</div>
				</div>
			</div>
			<div v-if="paged>1" v-for='(message,index) in messageList2' @click="toLinkUrl(index)" class="messageItem">
				<div class="messageImg">
					<img :src="message.imgUrl" />
				</div>
				<div class="messageItem_main">
					<div class="messageItem_title">{{message.title}}</div>
					<div class="messageItem_text">{{message.text}}</div>
				</div>
			</div>
			<div v-if="paged>2" v-for='(message,index) in messageList3' @click="toLinkUrl(index)" class="messageItem">
				<div class="messageImg">
					<img :src="message.imgUrl" />
				</div>
				<div class="messageItem_main">
					<div class="messageItem_title">{{message.title}}</div>
					<div class="messageItem_text">{{message.text}}</div>
				</div>
			</div>
		</div>
		<div v-if="paged<3" @click="showNext()" class="showMore">查看更多</div>
		<!--公共底部-->
		<div is='footed'></div>
	</div>
</template>

<script>
	import headered from '@/components/header';
	import footed from '@/components/foot';
	export default {
		name: 'index',
		components: {
			headered,
			footed
		},
		data() {
			return {
				paged: 1,
				//				资讯相关
				messageList: [
				{
						id: 37,
						imgUrl: 'https://static.feijingbang.com/upload/a6d546dc04d946d5818d76be50edc59a',
						title: '2020年国际大奖揭晓！ 中国的项目囊括金银铜三项全球大奖！',
						text: '喜报！中国的企业囊括了2020年度PE大奖中超大类型项目中的金奖、银奖和铜奖！',
						linkUrl: 'https://mp.weixin.qq.com/s/QsLTCB5aaqY3RsFtxbS7Sg'
					},
				
				{
						id: 1,
						imgUrl: 'https://static.feijingbang.com/upload/aaa58be3cb4d47579b49e66db115f74b',
						title: '我的未来--“小小项目师”远程支教',
						text: '20天线上课，千里之外的孩子打开摄像头更打开心扉',
						linkUrl: 'https://mp.weixin.qq.com/s/LJ4tSW8spfqWOu7Z6o9IPA'
					},
					{
						id: 35,
						imgUrl: 'https://static.feijingbang.com/upload/258b2032ef9e40a69345a97a4204a305',
						title: '线上1031/1101/06/07|2020中国项目管理高峰论坛',
						text: '2020相聚线上，精彩纷呈！',
						linkUrl: 'https://mp.weixin.qq.com/s/LQtKxAUjjIUuW2WCv-tEIQ'
					},
					{
						id: 36,
						imgUrl: 'https://static.feijingbang.com/upload/29ffa41ec9ed42f5a3a336fbad1228ed',
						title: '2020全国高等院校项目管理大赛（第五届）暨国际项目管理锦标赛中国区选拔赛圆满落下帷幕',
						text: '来自全国45所高校，103支代表队首次尝试了线上竞赛和云颁奖典礼',
						linkUrl: 'https://mp.weixin.qq.com/s/PXiA-82gTHFBZc_Ro0eWrA'
					},
					
					{
						id: 3,
						imgUrl: 'https://static.feijingbang.com/upload/2309eb59833e4a58be0ae73f5b8bf181',
						title: '2019中国项目管理大会暨中国特色与跨文化项目管理国际论坛圆满闭幕',
						text: '本届大会主题为“项目管理——系统化与敏捷化”。大会由中国优选法统筹法与经济数学研究会、国际项目管理协会（IPMA）支持，由中国优选法统筹法与经济数学研究会项目管理研究委员会（PMRC）与全国工程管理硕士专业学位研究生教育指导委员会、西北工业大学、《项目管理技术》杂志社、《项目管理评论》杂志社联合主办。',
						linkUrl: 'https://mp.weixin.qq.com/s/TOknM0zqTil6srU3ZOQ5Kw'
					},
					{
						id: 4,
						imgUrl: 'https://static.feijingbang.com/upload/210e83fcabc246da8c66acdf34225215',
						title: '“小小项目师”夏令营圆满成功！',
						text: '自我管理、创新发展!未来领袖培养计划',
						linkUrl: 'https://mp.weixin.qq.com/s/smqJWIhtilNlb6M5ej3EDg'
					},
					{
						id: 5,
						imgUrl: 'https://static.feijingbang.com/upload/922515e5c66748149e77ea824065e610',
						title: '重磅 | Praxis中国研究中心成立',
						text: '2018年12月11日下午，国际项目管理领域领先企业APMG International的Praxis中国研究中心成立会议和揭牌仪式在山东大学举行。',
						linkUrl: 'https://mp.weixin.qq.com/s/sOyZP8ItooUSWfCRYKs-Pg'
					},
					{
						id: 6,
						imgUrl: 'https://static.feijingbang.com/upload/1faf1eb2e6b348878778ac4219fb99f4',
						title: '做好VUCA时代的项目管理|2018中国项目管理大会在上海盛大召开',
						text: '盛况空前，群英荟萃',
						linkUrl: 'https://mp.weixin.qq.com/s/6ux0TZPvH13Tsql5jcy4jg'
					},
					{
						id: 7,
						imgUrl: 'https://static.feijingbang.com/upload/469766cfcf904e64895eb675d22cf6c0',
						title: '我的组织--第二届全国高校项目管理大赛圆满落幕',
						text: '一年一度的全国高校项目管理大赛又落下帷幕，盛况空前的颁奖典礼及参赛院校、人数均有扩展，由2016年的23所院校、45支队伍、180人参赛，扩展到34所院校、73支队伍、292名选手的参赛规模。',
						linkUrl: 'https://mp.weixin.qq.com/s/1h6Vokx-8IILica_bLZa7g'
					},
					{
						id: 8,
						imgUrl: 'https://static.feijingbang.com/upload/51f17e1a7fa64596927b0cab1d32d0b4',
						title: '霸屏: 梅州湾电力荣登世界舞台，荣获国际项目管理领域奥斯卡金奖',
						text: '2017年9月4日至7日，第30届IPMA（国际项目管理协会International Project Management Association）世界大会在哈萨克斯坦首都阿斯塔纳隆重举行。',
						linkUrl: 'https://mp.weixin.qq.com/s/3uuLIUaqqxivwlrLypkoOQ'
					},
					{
						id: 9,
						imgUrl: 'https://static.feijingbang.com/upload/276b12ce3ef342eda9d332b5d47b1436',
						title: '我的组织--“初创企业的创新路径”研讨沙龙',
						text: '北京项目管理协会的系列公益行活动，本次带给会员的福利是面对创业就业的初入职场青年的精神大餐。2017年8月29日下午北京项目管理协会“初创企业的创新路径”专题讲座在协会会议室乐凯大厦进行。',
						linkUrl: 'https://mp.weixin.qq.com/s/m8L5rrP5s_Zsz70PPpm73A'
					},
					{
						id: 10,
						imgUrl: 'https://static.feijingbang.com/upload/95d6440b5683494dbaf81ab4918261fd',
						title: '我的组织-当大V遇见大V',
						text: '2017年7月29日，北京项目管理协会项目管理公益行第6期召开，由北京项目管理协会BPMA与中国青年项目管理委员会CYC联合举行。沙龙嘉宾主要有北京项目管理协会副秘书长马延霖、中国青年委员会CYC副秘书长卢亮辉、协会副秘书长同时也是CYC副主席的郭雅等十几位人员。',
						linkUrl: 'https://mp.weixin.qq.com/s/n8TcVZLRmSFylZzyC-yyPA'
					},
					{
						id: 11,
						imgUrl: 'https://static.feijingbang.com/upload/126b9c565e5b403bb7fba0f44f90926a',
						title: '我的课堂--IPMP资质认证',
						text: '同学们，速来领取你的IPMP国际项目经理证书啦！！！~~~',
						linkUrl: 'https://mp.weixin.qq.com/s/49UfWkjMHvOrWD6D_aTeCQ'
					},
					{
						id: 12,
						imgUrl: 'https://static.feijingbang.com/upload/5672e3aa58954ee39716c17b267da1d8',
						title: '我的组织--《大学生自我管理》丛书发布会顺利召开',
						text: '我的组织--《大学生自我管理》丛书发布会顺利召开',
						linkUrl: 'https://mp.weixin.qq.com/s/DYr_PkFVYAhBZHXfIwtwRg'
					},
					{
						id: 13,
						imgUrl: 'https://static.feijingbang.com/upload/5add1ce11e844af98e914f2d625160ed',
						title: '【高端访谈】使命重在担当，实干铸就辉煌 | 访北京项目管理协会第三届理事长陈钟',
						text: '4月23日，北京项目管理协会(以下简称“协会”)换届大会在京举行，经投票产生了第三届理事会和监事会。北京大学信息科学技术学院教授、博士生导师陈钟当选为新一届理事长。',
						linkUrl: 'https://mp.weixin.qq.com/s/LasNtQro1LUojUkSe55CJg'
					},
				],
				messageList2: [
					{
						id: 14,
						imgUrl: 'https://static.feijingbang.com/upload/c02daa41c25a4cd789637c4cfbe501dd',
						title: '我的未来—IPMP助力国产大飞机 C919',
						text: '学习的路上永无止境	。',
						linkUrl: 'https://mp.weixin.qq.com/s/JmDw5OgThp1aeNkUxQ53RA'
					},
					{
						id: 15,
						imgUrl: 'https://static.feijingbang.com/upload/556206404d5c49a590ee7298df01dc1f',
						title: '我的组织--北京项目管理协会换届大会在京举行',
						text: '北京项目管理协会换届大会在京举行 北京大学陈钟教授当选新一届理事长',
						linkUrl: 'https://mp.weixin.qq.com/s/-0y1y6otRB6X4uUJaK_wLQ'
					},
					{
						id: 16,
						imgUrl: 'https://static.feijingbang.com/upload/1c6d8a5f3d7746c4968bc0f1cac89423',
						title: '我的组织--中国最高学术年会圆满落幕西安',
						text: '2016年11月底，国内最高规格的项目管理领域学术年会在古城西安隆重举行并完美落幕。',
						linkUrl: 'https://mp.weixin.qq.com/s/95AeoPmW7jgDM4qpntuqtA'
					},
					{
						id: 17,
						imgUrl: 'https://static.feijingbang.com/upload/b244bd01a79342b0af5bef48317415ad',
						title: '我的组织--首届全国高校项目管理大赛圆满落幕！',
						text: '在这里：“理论与实操的高度融合！个人与团队的深度较量！” 成就你：“非凡高超的职场技能！成竹在胸的创业梦想！” ',
						linkUrl: 'https://mp.weixin.qq.com/s/-SZud7CriOq5KM0OSYPhqQ'
					},
					{
						id: 18,
						imgUrl: 'https://static.feijingbang.com/upload/4a17dbc4514848809c3d094581746e64',
						title: '首届高校项目管理大赛来了！你准备好了吗！？',
						text: '以最好的姿态迎接首届高校项目管理大赛！',
						linkUrl: 'https://mp.weixin.qq.com/s/9odsX4TfTDdnRXCDB5FeqA'
					},
					{
						id: 19,
						imgUrl: 'https://static.feijingbang.com/upload/c69f06471b9644f79868da14bf43ffa0',
						title: '我的课堂--IPMP资质认证',
						text: '爽爽的八月底，焦虑加渴盼的心情伴随了30多位IPMP考生一个多月，终于看到又气派又权威的IPMP证书的模样了。随着第四次全国统考IPMP资质认证的日程，从7月初的每个周末起，北京航天某研究院的30多位IPMP-C级的学员在刻苦学习和讨论案例中度过了四个劳累又有意义的充实周末并交上了完美的答卷！',
						linkUrl: 'https://mp.weixin.qq.com/s/QD030JctybYXt0duHWJG4w'
					},
					{
						id: 20,
						imgUrl: 'https://static.feijingbang.com/upload/460b4e4ffcf84a1b9297f5d8608ce351',
						title: '项目管理校园行-燕山大学',
						text: '中国青年项目管理委员会CYC的企业导师、现任中国项目管理研究院副院长马旭晨教授，近日回到母校燕山大学访问交流，为在校师生做“用项目管理提升大学生就业与创业能力”的精彩讲座。',
						linkUrl: 'https://mp.weixin.qq.com/s/W-kOrDXKerQTNWxiFFdkDg'
					},
					{
						id: 21,
						imgUrl: 'https://static.feijingbang.com/upload/540dd80d0d0244feb55f8df85d2b17f8',
						title: '项目管理校园行—山东现代学院',
						text: '“项目管理校园行”活动目前遍布齐鲁大地的山东多所院校，山东现代学院（Shandong Modern University）是经教育部批准的全日制普通本科高等院校。',
						linkUrl: 'https://mp.weixin.qq.com/s/Cesgdd-R5k2tsBLKVzCY7g'
					},
					{
						id: 22,
						imgUrl: 'https://static.feijingbang.com/upload/c14b9ed45e3b42a9b90d714e93d90b53',
						title: '我的组织-中国青年项目管理CYC论坛成功举办',
						text: '2015年11月第十三届中国项目管理大会暨中国特色与跨文化项目管理国际论坛青年项目管理者（CYC）分论坛在西北工大学国际第一会议室举行，本次青年项目管理者论坛以“项目管理助理创新与成长”为主题。',
						linkUrl: 'https://mp.weixin.qq.com/s/eQvUcvPG7UXQaL3cORkcDg'
					},
					

				],
				messageList3: [
				{
						id: 23,
						imgUrl: 'https://static.feijingbang.com/upload/e5c90397ba654b23bc718e2047326f2d',
						title: '我的课堂--IPMP资质认证',
						text: '7月18日，项目管理IPMP认证的全国第四次笔试统考的日子，结合着北京暑伏天气的酷热，面对30多位申报C级认证考生来说，绝对是个阔别多年已久的黑色七月。',
						linkUrl: 'https://mp.weixin.qq.com/s/dnrR8eCzkfsiEqQbM6BOCw'
					},
					{
						id: 24,
						imgUrl: 'https://static.feijingbang.com/upload/adb57ac245b54765b94772517b69e714',
						title: '我的组织-中国项目管理应用与实践论坛',
						text: '由中国（双法）项目管理研究委员会（PMRC）主办的第八届“中国项目管理应用与实践论坛”于2015年6月底在北京举办,本届论坛主题为“项目管理助推企业变革与创新”。',
						linkUrl: 'https://mp.weixin.qq.com/s/8AJuC1qDrXB5OlPcO_XP9A'
					},
				{
						id: 25,
						imgUrl: 'https://static.feijingbang.com/upload/2cd880e532a0473aae245851d929d836',
						title: '项目管理校园行-山东科技学院',
						text: '项目管理校园行活动目前遍布齐鲁大地的山东多所院校，山东科技职业学院是省属国办全日制普通高校，是全国百所国家示范性院校之一。',
						linkUrl: 'https://mp.weixin.qq.com/s/A8GeF2NoUozZkZYmPPE3tQ'
					},
					{
						id: 26,
						imgUrl: 'https://static.feijingbang.com/upload/94f10d7dbf9b4b34970ccc17e36bc990',
						title: '项目管理校园行--华北电力大学',
						text: '又迎来了2015年的高校毕业季，今年全国大学毕业生已达749万，比去年的727万、前年的699万又创新高。',
						linkUrl: 'https://mp.weixin.qq.com/s/eG7iT8-hnOSUPJwZdHRVFA'
					},
					{
						id: 27,
						imgUrl: 'https://static.feijingbang.com/upload/14cd4bd31ae04c53b8a89b10402a30d3',
						title: '项目管理校园行-青岛职业学院',
						text: '青岛职业技术学院作为国家示范性高等职业院校，拥有国家教育数控实训基地、电子与自动化技术实训基地、全国物联网技术应用专业人才实训基地、全国农村信息化专业人才实训基地和国家首批高等职业学校骨干教师国家级培训项目基地等7个国家级实训基地。',
						linkUrl: 'https://mp.weixin.qq.com/s/LlsOmb2baDzxPX5CXBPFLA'
					},
					{
						id: 28,
						imgUrl: 'https://static.feijingbang.com/upload/235d2bfb474546e590c7fe9269d706b0',
						title: '我的课堂--IPMP-C级认证',
						text: '北京大学软件与微电子学院的在读和在职的十几位工程硕士、和已经获得IPMP-D级证书的毕业在职学员，在这个周末的两天与中科院研究生院的几十位工程硕士一起进行了IPMP-C级的认证考试。',
						linkUrl: 'https://mp.weixin.qq.com/s/6KFy4-WyHbX6uWiM4rfX2g'
					},
					{
						id: 29,
						imgUrl: 'https://static.feijingbang.com/upload/96fd84627aa047629b8623d029ce0fe2',
						title: '项目管理校园行---北京大学',
						text: '“人生成功与项目管理哲学思考”中国项目管理委员会常务委员，中国项目管理研究院副院长、中国青年项目管理俱乐部CYC的导师马旭晨教授以这个主题，于12月3日在北京大学软件与微电子学院的项目管理协会与同学们从全新的视角阐述了项目管理体系。',
						linkUrl: 'https://mp.weixin.qq.com/s/mK01qPeRTVk52QeL4PlHeA'
					},
					{
						id: 30,
						imgUrl: 'https://static.feijingbang.com/upload/01b42b9965134ed5a29eaa151883e28e',
						title: '我的组织-亚太大会青年项目管理论坛',
						text: '由国际项目管理协会、亚太项目管理联盟、中国(双法)项目管理研究委员会(PMRC)、全国项目管理领域工程硕士教育协办组、西北工业大学主办，项目管理者联盟网络支持的2014亚太项目管理大会于2014年11月29日-30日在国家会议中心圆满举办成功。',
						linkUrl: 'https://mp.weixin.qq.com/s/XFkiPLrBY8iTl6bz6okgNg'
					},
					{
						id: 31,
						imgUrl: 'https://static.feijingbang.com/upload/9511159f62c940cba0c2655146db1664',
						title: '项目管理校园行---华中科技大学',
						text: '2014年11月10日，中国青年项目管理委员会CYC副主席、北京安达思创首席讲师郭雅老师，应邀到湖北武汉的华中科技大学给管理学院的大二学生做了项目管理的案例演练课程。',
						linkUrl: 'https://mp.weixin.qq.com/s/-n47IdQiGP03mXWWwT7ldg'
					},
					{
						id: 32,
						imgUrl: 'https://static.feijingbang.com/upload/dedd9923b471496d8d0db62f411d70b6',
						title: '我的组织---亚太项目管理大会',
						text: '值2014年主题为"共建面向未来的亚太伙伴关系"的APEC会议在中国北京召开之际，一场跨越亚太、面向世界的项目管理国际盛会也将于2014年11月29日至30日在北京召开。',
						linkUrl: 'https://mp.weixin.qq.com/s/Q36Umv1KilmHGb9xy6aFoA'
					},
					{
						id: 33,
						imgUrl: 'https://static.feijingbang.com/upload/9dc0047426b540ee8166ca2307c18a8b',
						title: '我的组织-IPMP走进中国',
						text: 'IPMP-ABCD四级国际资质认证教育从2001年开始，在中国的管理培训咨询领域占据了不可动摇的坚实基础，成为继MBA、MPA、PMP等之后的中国又一大黄金执业证书。',
						linkUrl: 'https://mp.weixin.qq.com/s/4865_O1gIP6cU_f-_DrL-Q'
					},
					{
						id: 34,
						imgUrl: 'https://static.feijingbang.com/upload/2646aa6e70bd40bfbac220660a3b24dc',
						title: '2013年毕业季以来中国大学生就业报告',
						text: '面对2013年的就业现状，2014年高达727万的大学生毕业新生，面对未来我何去何从？',
						linkUrl: 'https://mp.weixin.qq.com/s/u28ihxkssoVhEmInx5gRAg'
					},
					
					{
						id: 2,
						imgUrl: 'https://static.feijingbang.com/upload/3dbb5f36fa544fc6b90d028b8a2d4e6e',
						title: '项目管理校园行—山东管理学院',
						text: '项目管理校园行又来了！山东管理学院是经国家教育部和山东省人民政府批准的具有普通高等学历教育招生资格的公办全日制普通本科学校。山东中医药大学是教育部本科教学工作水平评估优秀学校、山东省首批五所应用基础性人才培养特色名校之一，国内著名的项目管理专家马旭晨老师受邀到来到山东管理学院和山东医药大学进行讲座！',
						linkUrl: 'https://mp.weixin.qq.com/s/07kZQ4vglwIL6b8hpWyipg'
					},

				]
			}
		},
		methods: {
			toLinkUrl(index) {
				let linkUrl = this.messageList[index].linkUrl;
				window.open(linkUrl)
			},
			showNext(){
				let paged=this.paged;
				this.paged=paged+1
				
			}
		}
	}
</script>

<style scoped="scoped">
	.news_head {
		width: 1200px;
		margin: 0 auto;
		margin-top: 30px;
		line-height: 48px;
		font-size: 36px;
		font-weight: bold;
		margin-bottom: 30px;
	}
	
	.messageBox {
		width: 1200px;
		margin: 0 auto;
		position: relative;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: flex-start;
		flex-wrap: wrap;
	}
	
	.messageBox .messageItem {
		width: 220px;
		border-radius: 4px;
		box-shadow: 0px 6px 14px rgba(150, 150, 150, 0.8);
		margin-right: 25px;
		margin-bottom: 60px;
		cursor: pointer;
	}
	
	.messageBox .messageItem:nth-child(5n) {
		margin-right: 0px;
	}
	
	.messageBox .messageItem .messageImg {
		width: 220px;
		height: 200px;
		border-radius: 4px 4px 0px 0px;
		position: relative;
	}
	
	.messageBox .messageItem .messageImg img {
		width: 220px;
		height: 200px;
		border-radius: 4px 4px 0px 0px;
		position: absolute;
		left: 50%;
		margin-left: -110px;
	}
	
	.messageItem .messageItem_main {
		text-align: left;
		padding: 20px;
		min-height: 150px;
	}
	
	.messageItem_main .messageItem_title {
		line-height: 26px;
		font-size: 20px;
		font-weight: bold;
		margin-bottom: 12px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	
	.messageItem_main .messageItem_text {
		line-height: 24px;
		font-size: 16px;
		color: #707680;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}
	
	.showMore {
		width: 152px;
		height: 52px;
		line-height: 52px;
		border-radius: 26px;
		border: 1px solid #0080FF;
		font-size: 18px;
		color: #0080FF;
		margin: 0 auto;
		margin-bottom: 120px;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/views/news.vue